export default __webpack_public_path__ + "static/media/meiro-symbol-white-transparent.1bdcf891.svg";